import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import VM from 'scratch-vm';
import {STAGE_SIZE_MODES} from '../lib/layout-constants';
import {setStageSize} from '../reducers/stage-size';
import {setFullScreen} from '../reducers/mode';
import {openSettingsModal} from '../reducers/modals';

import {connect} from 'react-redux';

import StageHeaderComponent from '../components/stage-header/stage-header.jsx';
import isEqual from 'lodash.isequal';

// eslint-disable-next-line react/prefer-stateless-function
class StageHeader extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleKeyPress',

            'handleTriggerCoordinate',
            'handleZoomOutCoordinateFontSize',
            'handleZoomInCoordinateFontSize',
            'handleOpenStageNativeSizePopover',
            'handleCloseStageNativeSizePopover',
            'onSetStageNativeSize',
        ]);

        this.minCoordinateFontSize = 10;
        this.maxCoordinateFontSize = 18;
        this.coordinateFontSize = 14;

        this.state = {
            isShowCoordinate: false, // 是否显示坐标网格
            stageNativeSizePopoverOpen: false,//显示抽屉
        };
    }
    componentDidMount () {
        document.addEventListener('keydown', this.handleKeyPress);
    }
    componentWillUnmount () {
        document.removeEventListener('keydown', this.handleKeyPress);
    }
    handleKeyPress (event) {
        if (event.key === 'Escape' && this.props.isFullScreen) {
            this.props.onSetStageUnFull(false);
        }
    }
     /**
     * 触发坐标网格的显示 or 隐藏
     */
     handleTriggerCoordinate () {
        const visible = !this.state.isShowCoordinate;

        this.props.vm.runtime.triggerCoordinate(visible);

        this.setState({
            isShowCoordinate: visible
        });
    }

    /**
     * 缩小坐标系的字体
     */
     handleZoomOutCoordinateFontSize () {
        let temp = this.coordinateFontSize - 1;

        temp = temp >= this.minCoordinateFontSize ? temp : this.minCoordinateFontSize;

        this.coordinateFontSize = temp;
        this.props.vm.runtime.setCoordinateFontSize(temp);
    }

    /**
     * 放大坐标系的字体
     */
     handleZoomInCoordinateFontSize () {
        let temp = this.coordinateFontSize + 1;

        temp = temp <= this.maxCoordinateFontSize ? temp : this.maxCoordinateFontSize;

        this.coordinateFontSize = temp;
        this.props.vm.runtime.setCoordinateFontSize(temp);
    }
    /**
     * 打开 stageNativeSize 的 Popover 组件
     */
    handleOpenStageNativeSizePopover () {
        this.setState({stageNativeSizePopoverOpen: true});
    }

    /**
     * 关闭 stageNativeSize 的 Popover 组件
     */
    handleCloseStageNativeSizePopover () {
        this.setState({stageNativeSizePopoverOpen: false});
    }
    onSetStageNativeSize(item){
        const width = item[0]
        const height =item[1]
        if(isEqual([width,height],[0,0])){
            return
        }
        this.props.vm.setStageSize(width, height);
        this.props.vm.storeProjectOptions();
    }
    render () {
        const {
            ...props
        } = this.props;
        return (
            <StageHeaderComponent
                {...props}
                onKeyPress={this.handleKeyPress}
                isShowCoordinate={this.state.isShowCoordinate}
                onTriggerCoordinate={this.handleTriggerCoordinate}
                onZoomOutCoordinateFontSize={this.handleZoomOutCoordinateFontSize}
                onZoomInCoordinateFontSize={this.handleZoomInCoordinateFontSize}

                onSetStageNativeSize = {this.onSetStageNativeSize}
                stageNativeSizePopoverOpen={this.state.stageNativeSizePopoverOpen}
                onOpenStageNativeSizePopover={this.handleOpenStageNativeSizePopover}
                onCloseStageNativeSizePopover={this.handleCloseStageNativeSizePopover}
            />
        );
    }
}

StageHeader.propTypes = {
    isFullScreen: PropTypes.bool,
    // tw: update when dimensions or isWindowFullScreen changes
    isWindowFullScreen: PropTypes.bool,
    dimensions: PropTypes.arrayOf(PropTypes.number),
    isPlayerOnly: PropTypes.bool,
    onSetStageUnFull: PropTypes.func.isRequired,
    onOpenSettings: PropTypes.func.isRequired,
    // tw: replace showBranding
    isEmbedded: PropTypes.bool,
    stageSizeMode: PropTypes.oneOf(Object.keys(STAGE_SIZE_MODES)),
    vm: PropTypes.instanceOf(VM).isRequired
};

const mapStateToProps = state => ({
    stageSizeMode: state.scratchGui.stageSize.stageSize,
    // tw: replace showBranding
    isEmbedded: state.scratchGui.mode.isEmbedded,
    isFullScreen: state.scratchGui.mode.isFullScreen,
    // tw: update when dimensions or isWindowFullScreen changes
    isWindowFullScreen: state.scratchGui.tw.isWindowFullScreen,
    dimensions: state.scratchGui.tw.dimensions,
    isPlayerOnly: state.scratchGui.mode.isPlayerOnly
});

const mapDispatchToProps = dispatch => ({
    onSetStageLarge: () => dispatch(setStageSize(STAGE_SIZE_MODES.large)),
    onSetStageSmall: () => dispatch(setStageSize(STAGE_SIZE_MODES.small)),
    onSetStageFull: () => dispatch(setFullScreen(true)),
    onSetStageUnFull: () => dispatch(setFullScreen(false)),
    onOpenSettings: () => dispatch(openSettingsModal())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StageHeader);
